import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import { updateToken } from '@hobs/auth/actions';

import {
  list,
  homePage,
  terms,
  changeCurrentExerciseId,
  exerciseStaticData,
  exercisePost,
  exerciseGet,
  exercisePut,
  remainingDays,
  CURRENT
} from '@hobs/constants/exercises';

export function getExercises() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('Exercises')
      .then(response => {
        if (response) {
          dispatch(success(response.payload));
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: list.REQUEST };
  }
  function success(exercises) {
    return { type: list.SUCCESS, exercises };
  }
  function failure(error) {
    return { type: list.FAILURE, error };
  }
}

export function getExerciseHomePage() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('Exercises/HomePage')
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: homePage.REQUEST };
  }
  function success(page) {
    return { type: homePage.SUCCESS, page };
  }
  function failure(error) {
    return { type: homePage.FAILURE, error };
  }
}

export function getExerciseTerms() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('Exercises/Terms')
      .then(response => {
        if (response) {
          dispatch(success(response.payload));
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: terms.REQUEST };
  }
  function success(page) {
    return { type: terms.SUCCESS, page };
  }
  function failure(error) {
    return { type: terms.FAILURE, error };
  }
}

export function changeCurrentExercise(id) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`Account/ChangeCurrentExercise/${id}`, {
      method: 'POST'
    })
      .then(response => {
        if (response.payload && response.payload.token) {
          dispatch(updateToken(response.payload.token));
          dispatch(getCurrentExercise());
          dispatch(success());
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: changeCurrentExerciseId.REQUEST };
  }
  function success() {
    return { type: changeCurrentExerciseId.SUCCESS };
  }
  function failure(error) {
    return { type: changeCurrentExerciseId.FAILURE, error };
  }
}

/**
 * Some static data that needs to be used for exercise(for this moment only parties list)
 * @returns {Function}
 */
export function getExerciseStaticData() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('Exercises/ForSubmit')
      .then(response => {
        if (response) {
          dispatch(success(response.payload));
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: exerciseStaticData.REQUEST };
  }
  function success(response) {
    return { type: exerciseStaticData.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: exerciseStaticData.FAILURE, error };
  }
}

export function resetExerciseData() {
  return {
    type: exerciseGet.RESET
  };
}

export function createExercise(requestBody) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('Exercises', { body: requestBody, method: 'POST' })
      .then(response => {
        if (response) {
          if (response.status >= 400) {
            throw new Error(response.payload.message);
          }
          dispatch(success(response.payload));
          return { success: true };
        } else {
          dispatch(failure(response.payload.message));
          return { success: false, error: response.payload.message };
        }
      })
      .catch(error => {
        dispatch(failure(error));
        return { success: false, error: error.toString() };
      });
  };

  function request() {
    return { type: exercisePost.REQUEST };
  }
  function success(response) {
    return { type: exercisePost.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: exercisePost.FAILURE, error };
  }
}

export function updateExercise(requestBody, guid) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`Exercises/${guid}`, {
      body: requestBody,
      method: 'PUT'
    })
      .then(response => {
        if (response) {
          if (response.status >= 400) {
            throw new Error(response.payload.message);
          }
          dispatch(success(response.payload));
          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.payload.message));
          return { success: false, error: response.payload.message };
        }
      })
      .catch(error => {
        dispatch(failure(error));
        return { success: false, error: error.toString() };
      });
  };

  function request() {
    return { type: exercisePut.REQUEST };
  }
  function success(response) {
    return { type: exercisePut.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: exercisePut.FAILURE, error };
  }
}

export function getExercise(guid) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`Exercises/${guid}`)
      .then(response => {
        if (response.payload) {
          dispatch(success(response.payload));
          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: exerciseGet.REQUEST };
  }
  function success(response) {
    return { type: exerciseGet.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: exerciseGet.FAILURE, error };
  }
}

export function getCurrentExercise() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('Exercises/current')
      .then(response => {
        if (response.payload) {
          dispatch(success(response.payload));
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CURRENT.REQUEST };
  }
  function success(response) {
    return { type: CURRENT.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: CURRENT.FAILURE, error };
  }
}

export function getRemainingDaysObject() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('Exercise/RemainingPhaseDays')
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: remainingDays.REQUEST };
  }
  function success(response) {
    return { type: remainingDays.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: remainingDays.FAILURE, error };
  }
}
